import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useAuth } from '../../auth/core/Auth';
import axios from 'axios';

export const UploadConfirmation = () => {  
    const intl = useIntl();
    const { logout, currentUser, setCurrentUser } = useAuth();

  return (
    <div className="container">
          <div className='alert alert-primary'>{intl.formatMessage({ id: 'Please wait while your ID document is being reviewed by the Student Affairs office. You will receive a confirmation email once it is confirmed.' })}</div>

          <div className="row justify-content-end">
              <div className="col-xl-6 d-flex justify-content-end">
                  <Button variant='danger' onClick={logout}>
                      {intl.formatMessage({ id: 'Logout' })}
                  </Button>
              </div>
          </div>
    </div>
  );
};